module.exports = __webpack_public_path__ + "img/Organic-Logo.08295fe2.svg";